import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { endpoints } from "../../../api/endpoints";
import { getFetcher } from "../../../api/fetchers";
import Spinner from "../../components/spinner/Spinner";




const CompanyCamp = () => {
    const { supplierId } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [companyCamps, setCompanyCamps] = useState<any[]>([]);
    const [logoImage, setLogoImage] = useState('');

    const navigate = useNavigate();


    // request for company campaigns
    useEffect(() => {
        setIsLoading(true);
        const fetchCompanyCampaignsById = async () => {
            try {
                const response = await getFetcher(endpoints.campaigns.getCompanyCampaignsById.replace('{supplierId}', supplierId || ''));
                setCompanyCamps(response.companyCampaigns);
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchCompanyCampaignsById();
    }, [supplierId]);


    // FETCH SUPPLIER BY SUPPLIER ID
    useEffect(() => {
        const fetchSupplier = async () => {
            try {
                const response = await getFetcher(endpoints.supplier.getSupplierById.replace('{id}', supplierId || ''));
                setLogoImage(response.supplier.coverImg);
            } catch (error) {
                console.log(error);
            }
        }
        fetchSupplier();
    }, [supplierId]);


    // loading spinner
    if (isLoading) {
        return (
            <div className="flex flex-col min-h-screen">
                <Header />
                <Navbar />
                <main className="flex-grow flex justify-center items-center">
                    <Spinner />
                </main>
                <Footer />
            </div>
        );
    }



    const textCut = (text: string, length: number) => {
        return text.length > length ? text.substring(0, length) + '...' : text
    };

    return (
        <div className="flex flex-col min-h-screen ">
            {/* <Header />
            <Navbar /> */}
            <main className="flex-grow mb-20">
                <div className=" w-[calc(100%-72px)] mx-auto rounded-lg flex flex-col gap-y-5">
                    {/* BUTTON & BRAND*/}
                    <div className="flex w-11/12 mx-auto items-center gap-x-5 py-5  ">
                        <img src={logoImage} alt="companyCamp" className="w-20 h-20 sm:w-24 sm:h-24 rounded-full" />
                        <button
                            onClick={() => navigate(`/company-camp-product-list/${supplierId}`)}
                            className="bg-primary-color text-white px-4 rounded-md w-full sm:w-auto h-12 active:scale-95 transition hover:bg-opacity-80 ">
                            Mağazaya Git
                        </button>
                    </div>
                    {/* HEADER */}
                    <div className="flex justify-center items-center mb-10">
                        <img src={logoImage} alt="companyCamp" className=" w-full md:w-2/3 h-[300px] md:h-[400px] rounded-xl shadow-xl" />
                    </div>
                    {/* CARDS */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 w-full h-full ">
                        {companyCamps.map((campaign, index) => (
                            //<Link to={`/campaigns/${campaign.name.toLowerCase().replace(/\s+/g, '-')}`} key={index}>
                            <div className="flex flex-col md:flex-row gap-y-20 md:gap-y-0 h-full justify-start items-start">
                                <Link to={`/company-campaigns/company-camp/campaign-detail/${campaign.id}`}>
                                    <div key={index}
                                        className="rounded-2xl shadow-md flex flex-col lg:flex-row gap-10 lg:gap-8 mx-auto m-5 bg-white text-black justify-center items-center w-full  max-w-lg border-t-2 border-gray-300 cursor-pointer active:scale-95 transition hover:bg-opacity-80 h-full md:h-72">
                                        <img src={campaign.image} alt={campaign.name}
                                            className="lg:w-2/5 w-full h-full object-cover rounded-2xl " />
                                        <div
                                            className="p-4 flex flex-col justify-between flex-grow space-y-3 w-full lg:w-3/5 text-center lg:text-left">
                                            <p className="text-xl lg:text-3xl font-semibold text-primary-color">{campaign.title}</p>
                                            <p className="text-sm lg:text-base text-gray-500 md:hidden lg:flex">{textCut(campaign.description, 35 )}</p>
                                            <p className="text-md text-gray-700 flex justify-end h-full items-end ">{campaign.supplier.marketPlaceName}</p>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
            {/* <Footer /> */}
        </div>
    );
};

export default CompanyCamp;
